import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles(theme => ({
  pageCard: {
    backgroundColor: COLORS.WHITE,
    overflow: 'hidden',
  },
  pageTitle: {
    padding: '16px 24px 8px',
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    fontSize: 20,
    color: COLORS.PRIMARY,
  },
  pageBody: {
    padding: '8px 24px 16px',
  },
  pageActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px 24px 16px',
  },
  root: {
    flexGrow: 1,
    background: COLORS.WHITE,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  titleContainer: {
    margin: 10,
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    textAlign: 'left',
    margin: '0.5rem',
    color: theme.palette.primary.main,
    fontSize: 25,
    fontWeight: 600,
  },
  saveButton: {
    border: '2px solid',
    '&:hover': {
      border: '2px solid',
    },
    marginRight: 6,
  },
  divider: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: COLORS.BASE,
    marginBottom: 30,
  },
  dividerText: {
    color: COLORS.FONT,
    marginBottom: 5,
    marginLeft: 5,
    fontWeight: FONT_WEIGHT.semiBold,
    fontFamily: FONT_FAMILY,
  },
  dividerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  resetButton: {
    border: '2px solid',
    '&:hover': {
      border: '2px solid',
    },
    marginBottom: 20,
  },
  resetIcon: {
    color: theme.palette.primary.main,
  },
  input: {
    width: '100%',
  },
  rewardType: {
    textAlign: 'left',
    height: '10%',
    alignItems: 'center',
  },
  checkbox: {
    textAlign: 'right',
  },
  iconSection: {
    paddingLeft: '2rem',
    textAlign: 'left',
  },
  iconUploadContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  iconUploadPreviewContainer: {
    textAlign: 'center',
    border: '1px dashed #ccc',
    margin: '0 20px',
    height: '50px',
    width: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconPreview: { maxWidth: 30, maxHeight: '100%' },
}))

export { useStyles }
